var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-footer"},[_c('p',[_vm._v("Copyright © 2019 - "+_vm._s(_vm.dayjs().format('YYYY'))+" "),_c('a',{attrs:{"target":"_blank","href":"http://"}},[_vm._v("fastlog.id")]),_vm._v(" All Rights Reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }